module.exports = __webpack_public_path__ + "img/user_bg_certificate.112c286c.png";